export default class HeaderMenuControl {
  constructor(elem, opts) {
    this.elm = elem
    this.headerHiddenFlg = false
    this.menuOpenFlg = false
    this.eventBinds()
  }

  eventBinds() {
    this.addHeaderControl()
    this.addMenuControl()
  }

  addHeaderControl(){
    const _this = this
    let currentScrollAmount = window.scrollY
    window.addEventListener('scroll', () => {
      if(window.scrollY >= 100 && window.scrollY >= currentScrollAmount){
        if(!_this.headerHiddenFlg && !this.menuOpenFlg){
          _this.elm.classList.add('is-hide')
          _this.headerHiddenFlg = true
        }
      }else{
        if(_this.headerHiddenFlg){
          _this.elm.classList.remove('is-hide')
          _this.headerHiddenFlg = false
        }
      }
      currentScrollAmount = window.scrollY
    })
  }

  addMenuControl(){
    const headerMenuBtnElm = document.getElementById('headerMenuBtn')
    const headerMenuModalElm = document.getElementById('headerMenuModal')
    headerMenuBtnElm.addEventListener('click', () => {
      if(headerMenuModalElm.classList.contains('is-active')){
        headerMenuBtnElm.classList.remove('is-active')
        headerMenuModalElm.classList.remove('is-active')
        this.menuOpenFlg = false
      }else{
        headerMenuBtnElm.classList.add('is-active')
        headerMenuModalElm.classList.add('is-active')
        this.menuOpenFlg = true
      }
    })

    const headerMenuLinkElmAry = headerMenuModalElm.getElementsByTagName('a')
    for(let i=0; i<headerMenuLinkElmAry.length; i++){
      headerMenuLinkElmAry[i].addEventListener('click', () => {
        headerMenuBtnElm.classList.remove('is-active')
        headerMenuModalElm.classList.remove('is-active')
        this.menuOpenFlg = false
      })
    }
  }
}